import { baseUrl } from "../../../config/url-config/index";
import axiosInstance from "../axiosInstance";

const Put = async (path, data) => {
  try {
    const result = await axiosInstance.put(`${baseUrl}/${path}`, data);
    return result;
  } catch (err) {
    throw err;
  }
};

export default Put;
